import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { NextImage } from '@/components/NextImage';

export const Container = styled(Box)`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
`;

export const FormWrapper = styled(Flex)`
  flex-direction: column;
  ${({ theme }) => css`
    gap: ${theme.spacing(2)};
  `}
`;

export const Image = styled(NextImage)`
  width: 100%;
  height: auto;
  margin-top: ${({ theme }) => theme.spacing(2)};
`;
